export class ErrorMessageHelper {
  public async createErrorMessage(error: string): Promise<string> {
    const errorMessage = '<strong>' + error + '</strong>';

    return errorMessage;
  }
}
